import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { calculateOffset, PriorityEmailType, PriorityInvitesEmptyState, showErrorNotification, showSuccessNotification, TablePagination, useDeletePriorityEmailRecordMutation, useGetPriorityEmailRecordCountQuery, useGetPriorityEmailRecordsQuery, useResendPriorityEmailRecordEmailMutation } from "../../shared/Internal";
import { GlobalInviteRow } from "./GlobalInviteRow";
import { ManagedTable } from "../../shared/ManagedTable";
export const GlobalInviteView = ({ search = "", isActiveTab }) => {
    // State
    const [page, setPage] = useState(1);
    // Effects
    useEffect(() => {
        setPage(1);
    }, [search]);
    // Queries
    const [{ data, fetching }] = useGetPriorityEmailRecordsQuery({
        requestPolicy: "cache-and-network",
        variables: {
            search,
            offset: calculateOffset(page),
            type: PriorityEmailType.PriorityOrganizationInvite
        },
        pause: isActiveTab === false
    });
    const priorityEmailRecords = data?.priorityEmailRecords?.priorityEmailRecords ?? [];
    // Get the priority email record count.
    const [{ data: countData }] = useGetPriorityEmailRecordCountQuery({
        variables: {
            search,
            type: PriorityEmailType.PriorityOrganizationInvite
        },
        pause: isActiveTab === false
    });
    const count = countData?.priorityEmailRecords?.priorityEmailRecordCount ?? 0;
    // Mutations
    const [, resendPriorityEmailRecord] = useResendPriorityEmailRecordEmailMutation();
    const [, deletePriorityEmailRecord] = useDeletePriorityEmailRecordMutation();
    // Handlers
    const handleResendInvite = async (priorityEmailRecordId) => {
        if (!priorityEmailRecordId)
            return;
        resendPriorityEmailRecord({
            priorityEmailRecordId
        }).then(({ error }) => {
            if (error) {
                showErrorNotification("An error occurred, the invite was not resent.");
            }
            else {
                showSuccessNotification("Invite resent!");
            }
        });
    };
    const handleDeleteInvite = async (priorityEmailRecordId) => {
        if (!priorityEmailRecordId)
            return;
        deletePriorityEmailRecord({
            priorityEmailRecordId
        }).then(({ error }) => {
            if (error) {
                showErrorNotification("An error occurred, the invite was not deleted.");
            }
            else {
                showSuccessNotification("Invite deleted!");
            }
        });
    };
    /**
     * Create the table header
     */
    const tableHead = (_jsxs(Table.Tr, { children: [_jsx(Table.Th, { children: "Inviting User" }), _jsx(Table.Th, { children: "Patient" }), _jsx(Table.Th, { children: "Status" }), _jsx(Table.Th, { children: "Therapy Needed" }), _jsx(Table.Th, { children: "Primary Contact" }), _jsx(Table.Th, { children: "Location" }), _jsx(Table.Th, { style: { width: "50px" } })] }));
    // Global Invite Rows
    const globalInviteRows = useMemo(() => {
        return priorityEmailRecords.map((priorityEmailRecord) => (_jsx(GlobalInviteRow, { globalInvite: priorityEmailRecord, onResendInvite: () => handleResendInvite(priorityEmailRecord.priorityEmailRecordId), onDeleteInvite: () => handleDeleteInvite(priorityEmailRecord.priorityEmailRecordId) }, priorityEmailRecord.priorityEmailRecordId)));
    }, [priorityEmailRecords]);
    const caption = _jsx(TablePagination, { count: count, page: page, setPage: setPage });
    return (_jsx(ManagedTable, { withBorder: true, header: tableHead, rows: globalInviteRows, caption: caption, minWidth: 800, fetching: fetching, emptyState: _jsx(PriorityInvitesEmptyState, {}) }));
};
